import { useRef, useEffect } from 'react';

/**
 * A hook to track if a component is currently mounted.
 * It is useful to prevent setting state on an unmounted component.
 *
 * Usage:
 * ```
 * const isMounted = useIsMounted();
 *
 * asyncOperation().then(data => {
 * 	if (isMounted.current) { setState(data); }
 * })
 * ```
 */
const useIsMounted = () => {
	const isMounted = useRef(false);

	useEffect(() => {
		isMounted.current = true;
		return () => (isMounted.current = false);
	}, []);

	return isMounted;
};

export { useIsMounted };
